module.exports = __webpack_public_path__ + "images/emoji/dvd.73d43b648a2a23b5b31d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dvd.png
// module id = tJK1
// module chunks = 13